import { UrlBuilderTypes } from './types';

export const SetUrlBuilderData = (data: any) => ({
 type: UrlBuilderTypes.SET_BUILDER_DATA,
 data,
});

export const SetUrlBuilderPublish = (data: boolean) => ({
    type: UrlBuilderTypes.SET_BUILDER_PUBLISH,
    published: data,
   });

export const SetBuilderPermissions = (data: any) => ({
 type: UrlBuilderTypes.SET_BUILDER_PERMISSIONS,
 data,
});

export const UpdateBuilderPermissions = (data: any) => ({
 type: UrlBuilderTypes.UPDATE_BUILDER_PERMISSIONS,
 data,
});
